import React, { useRef } from "react";
import { Col } from "antd";
import { useTranslation } from "react-i18next";
import {
  ComposedChart,
  XAxis,
  YAxis,
  ResponsiveContainer,
  CartesianGrid,
  Bar,
  Cell,
} from "recharts";

import { DownloadIcon } from "icons";
import { generateImg } from "utils";

import {
  BoxHeader,
  LightDivider4Chart,
  BoxContent4Chart,
  BoxItem4DisorderChart,
  ContainerChart,
  WrapperChart,
} from "../Dashboard.style";

const COLORS = [
  "#3B3B3B",
  "#CCCCCC",
  "#B3B3B3",
  "#999999",
  "#CCCCCC",
  "#666666",
];

const tickFormatter = (value: string) => {
  const limit = 7;
  if (value.length < limit) return value;
  return `${value.substring(0, limit)}...`;
};

const Consultation = ({ data }: any) => {
  const imgRef = useRef<any>();

  return (
    <Col xs={24} md={24} xl={12} ref={imgRef}>
      <BoxItem4DisorderChart>
        <BoxHeader>
          <div></div>
          <DownloadIcon
            fill="#3B3B3B"
            style={{ marginTop: 4, cursor: "pointer" }}
            onClick={(event: any) => {
              if (!event.detail || event.detail == 1) {
                generateImg("physical-disorder", imgRef.current);
              }
            }}
          />
        </BoxHeader>
        <LightDivider4Chart />
        <BoxContent4Chart>
          <WrapperChart>
            <ContainerChart>
              <ResponsiveContainer width="100%" height={250}>
                <ComposedChart
                  layout="vertical"
                  data={data}
                  margin={{
                    top: 10,
                    right: 0,
                    bottom: 20,
                    left: 50,
                  }}
                >
                  <CartesianGrid stroke="#f5f5f5" />
                  <XAxis
                    type="number"
                    tickLine={{ transform: "translate(0, -7)" }}
                  />
                  <YAxis
                    dataKey="name"
                    type="category"
                    scale="auto"
                    tickLine={false}
                    tickFormatter={tickFormatter}
                  />
                  <Bar dataKey="pv" barSize={24} fill="#413ea0">
                    {data.map((entry: any, index: number) => (
                      <Cell key={`cell-${index}`} fill={COLORS[index]} />
                    ))}
                  </Bar>
                </ComposedChart>
              </ResponsiveContainer>
            </ContainerChart>
          </WrapperChart>
        </BoxContent4Chart>
      </BoxItem4DisorderChart>
    </Col>
  );
};

export default Consultation;
